import type { Directive } from 'vue'
import { imageViewer } from "../../components/ImageViewer/ImageViewer"

const imgClick : Directive = {
	mounted(el : HTMLElement) : void {
		setTimeout(() => {
			let arr: any = []
			el.querySelectorAll('img').forEach(img => {
				arr.push(img.src)
				img.addEventListener('click', function () {
					// 执行点击图片时的逻辑
					console.log('Image clicked:', img.src);
					// 可以在这里执行其他逻辑，例如弹窗显示图片等
					imageViewer({
						list: arr,
						index: arr.indexOf(img.src),
						onClose: () => {}
					})
				});
			});
		}, 400)
	},
}

export default imgClick